import { DatePicker, FilterModal, SelectSearch } from "components"
import { useFormikContext } from "formik"
import { useQuery } from "react-query"
import { DateConvert } from "utilities"
import LaporanHPPApi from "../Service"

export const ModalFilter = ({ toggle }) => {
  const { values, handleSubmit, setValues, setFieldValue } = useFormikContext()

  const {
    data: dropdownBarangJadi,
    isFetching: loadingDropdownBarangJadi,
  } = useQuery(["dropdownBarangJadi", "dropdown"], () =>
    LaporanHPPApi.getDropdownBarangJadi()
  )

  const {
    data: dropdownUnitProduksi,
    isFetching: loadingUnitProduksi,
  } = useQuery(["dropdownUnitProduksi", "dropdown"], () =>
    LaporanHPPApi.getDropdownUnitProduksi()
  )

  // HANDLE RESET
  const onResetButtonClick = (setValues) => {
    const myPromise = new Promise((resolve) => {
      setValues({
        tgl_realisasi_produksi_mulai: undefined,
        tgl_realisasi_produksi_selesai: undefined,
        tgl_produksi_mulai: undefined,
        tgl_produksi_selesai: undefined,
        tgl_hpp_mulai: undefined,
        tgl_hpp_selesai: undefined,
        id_barang_jadi: undefined,
        id_unit_produksi: undefined,
      })

      setTimeout(() => resolve(), 300)
    })

    myPromise.then(() => { })
  }

  const onTanggalChange = (
    dates,
    values,
    setValues,
    value_awal,
    value_akhir
  ) => {
    const [start, end] = dates
    const startDate = start ? DateConvert(start).default : undefined
    const endDate = end ? DateConvert(end).default : undefined

    setValues({
      ...values,
      [value_awal]: startDate,
      [value_akhir]: endDate,
    })
  }

  return (
    <FilterModal
      isToggle
      toggleModal={toggle}
      onResetButtonClick={() => onResetButtonClick(setValues)}
      onFilterButtonClick={handleSubmit}
    >
      <DatePicker
        selectsRange
        label="Tgl. Realisasi Produksi"
        placeholderText="Pilih tanggal"
        dateFormat="dd/MM/yyyy"
        startDate={
          values?.tgl_realisasi_produksi_mulai
            ? new Date(values?.tgl_realisasi_produksi_mulai)
            : ""
        }
        endDate={
          values?.tgl_realisasi_produksi_selesai
            ? new Date(values?.tgl_realisasi_produksi_selesai)
            : ""
        }
        onChange={(dates) =>
          onTanggalChange(
            dates,
            values,
            setValues,
            "tgl_realisasi_produksi_mulai",
            "tgl_realisasi_produksi_selesai"
          )
        }
        monthsShown={2}
      />

      <DatePicker
        selectsRange
        label="Tgl. Produksi"
        placeholderText="Pilih tanggal"
        dateFormat="dd/MM/yyyy"
        startDate={
          values?.tgl_produksi_mulai
            ? new Date(values?.tgl_produksi_mulai)
            : ""
        }
        endDate={
          values?.tgl_produksi_selesai
            ? new Date(values?.tgl_produksi_selesai)
            : ""
        }
        onChange={(dates) =>
          onTanggalChange(
            dates,
            values,
            setValues,
            "tgl_produksi_mulai",
            "tgl_produksi_selesai"
          )
        }
        monthsShown={2}
      />

      <DatePicker
        selectsRange
        label="Tgl. HPP"
        placeholderText="Pilih tanggal"
        dateFormat="dd/MM/yyyy"
        startDate={
          values?.tgl_hpp_mulai ? new Date(values?.tgl_hpp_mulai) : ""
        }
        endDate={
          values?.tgl_hpp_selesai ? new Date(values?.tgl_hpp_selesai) : ""
        }
        onChange={(dates) =>
          onTanggalChange(
            dates,
            values,
            setValues,
            "tgl_hpp_mulai",
            "tgl_hpp_selesai"
          )
        }
        monthsShown={2}
      />

      <SelectSearch
        label="Barang Jadi"
        option={dropdownBarangJadi}
        loading={loadingDropdownBarangJadi}
        placeholder="Semua"
        defaultValue={
          values?.id_barang_jadi
            ? dropdownBarangJadi?.find(
              (val) => val?.value === values?.id_barang_jadi
            )
            : undefined
        }
        onChange={(val) => setFieldValue("id_barang_jadi", val?.value)}
      />

      <SelectSearch
        label="Unit Produksi"
        option={dropdownUnitProduksi}
        loading={loadingUnitProduksi}
        placeholder="Semua"
        defaultValue={
          values?.id_unit_produksi
            ? dropdownUnitProduksi?.find(
              (val) => val?.value === values?.id_unit_produksi
            )
            : undefined
        }
        onChange={(val) => setFieldValue("id_unit_produksi", val?.value)}
      />
    </FilterModal>
  )
}
